/**
 * 商行健康度 - Redux actions
 */
import * as actionTypes from '../constant/stallHealth';

/** 设置查询条件（会重置 pageNo 为 1） */
export function setQueryFilters(payload) {
  return { type: actionTypes.STALL_HEALTH_SET_FILTERS, payload };
}

/** 设置列表数据，payload 可为 { list, total } 或 list 数组 */
export function setList(payload) {
  const list = Array.isArray(payload?.list) ? payload.list : Array.isArray(payload) ? payload : [];
  const total = payload?.total != null ? payload.total : list.length;
  return {
    type: actionTypes.STALL_HEALTH_SET_LIST,
    payload: {
      list,
      total,
      healthLevel: payload?.healthLevel ?? null,
      healthScore: payload?.healthScore ?? null,
    },
  };
}

/** 设置分页 */
export function setPagination(payload) {
  return { type: actionTypes.STALL_HEALTH_SET_PAGINATION, payload };
}

/** 设置加载状态 */
export function setLoading(loading) {
  return { type: actionTypes.STALL_HEALTH_SET_LOADING, payload: loading };
}

/** 重置查询条件与列表 */
export function resetStallHealth() {
  return { type: actionTypes.STALL_HEALTH_RESET };
}
